import { render } from "./TitleH2.vue?vue&type=template&id=37566d7e&scoped=true"
import script from "./TitleH2.vue?vue&type=script&lang=js"
export * from "./TitleH2.vue?vue&type=script&lang=js"

import "./TitleH2.vue?vue&type=style&index=0&id=37566d7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37566d7e"]])

export default __exports__